if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Prüfen ob Stitching konfiguriert ist
        const stitchingTextInput = document.getElementById('stitching-text-hidden');
        const hasStitchingText = stitchingTextInput && stitchingTextInput.value && stitchingTextInput.value.trim() !== '';

        if (hasStitchingText) {
          // Stitching-Verarbeitung
          this.handleStitchingSubmission();
        } else {
          // Normale Produkt-Verarbeitung
          this.handleNormalSubmission();
        }
      }

      handleStitchingSubmission() {
        // Prevent double submission
        if (this.form.dataset.submitting === 'true') {
          return;
        }
        this.form.dataset.submitting = 'true';

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        if(this.querySelector('.quick-add-icon')){
          this.querySelector('.quick-add-icon').classList.add('hidden');
        }

        // Sicherstellen, dass Stitching-Properties im Formular sind
        this.ensureStitchingPropertiesInForm();

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const variantQuantity = formData.get('quantity') || 1;

        // Hauptprodukt hinzufügen
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then((response) => response.json())
        .then((data) => {
          console.log('Main product added with properties:', data);

          // Stitching-Service hinzufügen
          const additionalProductId = document.querySelector('[data-stitching-service-id]')?.dataset.stitchingServiceId;
          if (!additionalProductId) {
            throw new Error('Stitching service ID not found');
          }

          const stitchingElement = document.querySelector('[data-stitching-service-id]');
          const textKey = stitchingElement?.dataset.stitchingTextKey || 'Bestickung Text';
          const colorKey = stitchingElement?.dataset.stitchingColorKey || 'Bestickung Farbe';
          const fontKey = stitchingElement?.dataset.stitchingFontKey || 'Bestickung Schrift';
          const idKey = stitchingElement?.dataset.stitchingIdKey || 'Bestickung ID';

          const additionalProductData = {
            id: additionalProductId,
            quantity: variantQuantity,
            properties: {
              [`_${textKey}`]: formData.get(`properties[${textKey}]`),
              [`_${colorKey}`]: formData.get(`properties[${colorKey}]`),
              [`_${fontKey}`]: formData.get(`properties[${fontKey}]`),
              [`_${idKey}`]: formData.get("id"),
            }
          };

          return fetch('/cart/add.js', {
            method: 'POST',
            body: JSON.stringify(additionalProductData),
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          });
        })
        .then((response) => response.json())
        .then((data) => {
          console.log('Stitching service added:', data);
          
          // Cart aktualisieren
          this.updateCartAfterStitching();
          
          // Stitching-Inputs zurücksetzen
          this.resetStitchingInputs();

          // Publish cart update event
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form-stitching',
            productVariantId: variantId,
            cartData: data,
          });
        })
        .catch((error) => {
          console.error('Error:', error);
          this.handleErrorMessage('Fehler beim Hinzufügen der Bestickung');
        })
        .finally(() => {
          this.form.dataset.submitting = 'false';
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          if(this.querySelector('.quick-add-icon')){
            this.querySelector('.quick-add-icon').classList.remove('hidden');
          }
        });
      }

      handleNormalSubmission() {
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        if(this.querySelector('.quick-add-icon')){
          this.querySelector('.quick-add-icon').classList.add('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if(this.querySelector('.quick-add-icon')){
                this.querySelector('.quick-add-icon').classList.remove('hidden');
            }
          });
      }

      ensureStitchingPropertiesInForm() {
        const stitchingTextInput = document.getElementById('stitching-text-hidden');
        const stitchingColorInput = document.getElementById('stitching-color-hidden');
        const stitchingFontInput = document.getElementById('stitching-font-hidden');

        if (stitchingTextInput && stitchingTextInput.value && !this.form.contains(stitchingTextInput)) {
          this.form.appendChild(stitchingTextInput);
        }
        if (stitchingColorInput && stitchingColorInput.value && !this.form.contains(stitchingColorInput)) {
          this.form.appendChild(stitchingColorInput);
        }
        if (stitchingFontInput && stitchingFontInput.value && !this.form.contains(stitchingFontInput)) {
          this.form.appendChild(stitchingFontInput);
        }
      }

      updateCartAfterStitching() {
        fetch('/cart')
          .then((response) => response.text())
          .then((html) => {
            const newCartDrawer = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('.cart-drawer');
            if (document.querySelector('.cart-drawer')) {
              document.querySelector('.cart-drawer').innerHTML = newCartDrawer.innerHTML;
            }
            
            // Cart-Drawer öffnen
            if (this.cart) {
              if (this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }
              if (typeof this.cart.open === 'function') {
                this.cart.open();
              }
            }
          })
          .catch((error) => {
            console.error('Error updating cart drawer:', error);
          });
      }

      resetStitchingInputs() {
        // Diese Funktion ruft die globale Reset-Funktion auf
        if (typeof window.resetStitchingInputs === 'function') {
          window.resetStitchingInputs("buy-button");
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
